import CampaignLuckyDrawPanel from './campaignLuckyDraw.container';

export default CampaignLuckyDrawPanel;